import { __assign, __extends } from "tslib";
/* I86 in DS */
// from GDrive
import React from 'react';
import IconWrap from '../IconWrap';
var ArrowLongLeft = /** @class */ (function (_super) {
    __extends(ArrowLongLeft, _super);
    function ArrowLongLeft() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ArrowLongLeft.prototype.render = function () {
        return (React.createElement(IconWrap, __assign({}, this.props),
            React.createElement("svg", { width: "0", height: "0", viewBox: "0 0 24 24", version: "1.1", xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink" },
                React.createElement("path", { d: "M10.867 8.076c-.367-.429-1.05-1.107-1.05-1.107L5.03 12.087 9.89 16.97l1.14-1.078-3.167-3.077H18.97v-1.525H7.888l2.98-3.213z" }))));
    };
    return ArrowLongLeft;
}(React.Component));
export { ArrowLongLeft };
export default ArrowLongLeft;
//# sourceMappingURL=ArrowLongLeft.js.map